export const isVkSocialAccount = ({ isSocialAccount = false, socialProviders = [] } = {}) =>
    Boolean(isSocialAccount) &&
    Array.isArray(socialProviders) &&
    socialProviders.some((provider) => String(provider).trim().toLowerCase() === "vk");

export const canUseFullApp = ({
    emailConfirmed = false,
    isSocialAccount = false,
    socialProviders = [],
} = {}) =>
    Boolean(emailConfirmed) || isVkSocialAccount({ isSocialAccount, socialProviders });
